@if (add_to_project_msg) {
  <div class="alert alert-success alert-dismissible" role="alert">
    {{ add_to_project_msg }}
    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </p-button>
  </div>
}
@if (add_to_project_grp_msg) {
  <div class="alert alert-success alert-dismissible" role="alert">
    {{ add_to_project_grp_msg }}
    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </p-button>
  </div>
}
@if (add_to_project_error_msg) {
  <div class="alert alert-warning alert-dismissible" role="alert">
    {{ add_to_project_error_msg }}
    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </p-button>
  </div>
}
@if (remove_from_project_msg) {
  <div class="alert alert-success alert-dismissible" role="alert">
    {{ remove_from_project_msg }}
    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </p-button>
  </div>
}
@if (remove_from_project_error_msg) {
  <div class="alert alert-warning alert-dismissible" role="alert">
    {{ remove_from_project_error_msg }}
    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </p-button>
  </div>
}

<div class="form-group row">
  <div class="col-sm-6">
    <label for="newproject" class="col-form-label">Projects</label>
    <select id="newproject" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.newproject" class="form-control">
      @for (project of projects; track project) {
        <option [ngValue]="project">{{ project.id }}</option>
      }
    </select>
  </div>
</div>
<div class="form-group">
  <p-button severity="primary" size="small" type="button" (onClick)="add_to_project()" label="Add to project"></p-button>
</div>
<hr />
<div class="table-responsive">
  @if (user_projects.length > 0) {
    <table class="table table-striped">
      <thead>
        <th>Name</th>
        <th>Group</th>
        <th>Owner?</th>
        <th>Manager?</th>
        <th>User in group?</th>
        <th></th>
      </thead>
      <tbody>
        @for (project of user_projects; track project) {
          <tr>
            <td>
              <a routerLink="/admin/project/{{ project.id }}">
                <span class="p-button p-button-sm p-button-primary">{{ project.id }}</span>
              </a>
            </td>
            <td>
              <span>{{ project.group }}</span>
            </td>
            <td>@if (project.owner) {
              <span>x</span>
            }</td>
            <td>@if (project.is_manager) {
              <span>x</span>
            }</td>
            <td>@if (project.member) {
              <span>x</span>
            }</td>
            <td><app-my-delete-confirm [onConfirm]="remove_from_project" [data]="project.id"></app-my-delete-confirm></td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
